import {
	AccreditationDetails,
	InvestorVerificationDocument,
	UpgradeFlowAccreditationSelection
} from 'types/accreditation';
import { investmentEntityRequest } from '@utils/request';
import moment from 'moment';

export async function updateVerificationDocument(
	investorVerificationDocument: InvestorVerificationDocument
): Promise<void> {
	await investmentEntityRequest.post(`/investor-verification-document/update`, investorVerificationDocument);
}

export async function setUnverifiedAccreditation(
	accreditationSelection: UpgradeFlowAccreditationSelection
): Promise<void> {
	await investmentEntityRequest.post(`/accreditation/update`, accreditationSelection);
}


export async function getAccreditationDetails(): Promise<AccreditationDetails> {
	const response = await investmentEntityRequest.get(`/accreditation/details`);
	const accreditation = response.data as AccreditationDetails;
	if (accreditation.verificationApprovalDate) {
		accreditation.verificationApprovalDate = moment(accreditation.verificationApprovalDate).format('MMM D, YYYY');
	}
	if (accreditation.verificationExpirationDate) {
		accreditation.verificationExpirationDate = moment(accreditation.verificationExpirationDate).format('MMM D, YYYY');
	}

	accreditation.investorVerificationDocumentDtos.forEach((document: InvestorVerificationDocument) => {
		if (document.approvalDate) {
			document.approvalDate = moment(document.approvalDate).format('MMM D, YYYY');
		}
		if (document.expirationDate) {
			document.expirationDate = moment(document.expirationDate).format('MMM D, YYYY');
		}
	});
	return accreditation;
}
